import Vue from "vue";
import Router from "vue-router";
import home from "./views/home.vue";

Vue.use(Router);

export default new Router({
  routes: [
    // 路由懒加载示例
    // {
    //   path: "/path",
    //   name: "name",
    //   component: () => import("./views/*.vue")
    // }
    {
      path: "*",
      redirect: "/home"
    },
    {
      path: "/home",
      name: "home",
      component: home,
      meta: { keepAlive: true }
    }
  ]
});
